import { ChangeEvent, useState, useEffect } from 'react'
import { Tooltip } from '@mui/material'
import classNames from 'classnames'
import { useField } from 'formik'
import { useTranslation } from 'react-i18next'
import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'
import IconButton from 'src/components/shared/ui/IconButton'
import { SearchIcon } from 'src/components/shared/ui/Icons'
import { fieldsStyles as styles } from 'src/components/shared/ui/form/fields/fieldsStyles'
import { useAlertContext } from 'src/contexts/AlertContext'
import { DocumentosPermitidos } from 'src/enums/EscritosLegales'
import useInputFile from 'src/hooks/useInputFile'

type Props = {
  id: string
  required?: boolean
  multiple?: boolean
  disabled?: boolean
}

function InputFileButton({
  id,
  required = false,
  multiple = false,
  disabled = false
}: Props): JSX.Element {
  const { addAlert } = useAlertContext()
  const [_fieldInfo, meta] = useField(id)
  const { t } = useTranslation()
  const tooltipTitle = t('tooltips.browseComputer')
  const inputClassNames = classNames({
    required,
    error: meta.error
  })

  const { setInputFile, closeWarning, errors } = useInputFile({
    id,
    multiple
  })

  const [fileInputRef, setFileInputRef] = useState<any>()

  async function handleChange(event: ChangeEvent<HTMLInputElement>) {
    if (event.target.files && event.target.files[0]) {
      setInputFile(event.target.files[0])
    }
    setTimeout(() => {
      fileInputRef.value = ''
    })
  }

  useEffect(
    () => {
      if (errors[id] && errors[id] !== '') {
        addAlert({
          message: errors[id],
          type: AlertType.ERROR,
          closeAction: closeWarning
        })
      }
    },
    // eslint-disable-next-line
    [errors[id]]
  )

  return (
    <label htmlFor={id} className={inputClassNames}>
      <input
        style={{ display: 'none' }}
        id={id}
        ref={ref => {
          setFileInputRef(ref)
        }}
        type="file"
        accept={multiple ? DocumentosPermitidos.ANEXOS : DocumentosPermitidos.PRINCIPAL}
        onChange={handleChange}
        disabled={disabled}
      />
      <Tooltip title={tooltipTitle} placement="top" componentsProps={styles}>
        <IconButton
          aria-label={t('form.button.label.buscar_destinatarios')}
          component="span"
          disabled={disabled}
          size="large"
        >
          <SearchIcon />
        </IconButton>
      </Tooltip>
    </label>
  )
}

export default InputFileButton
